import styled from 'styled-components'
import { darken } from 'polished'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  ${props => props.theme.css.container};
  text-align: center;
  line-height: 2;
  padding: 0 20px !important;

  > p {
    font: ${font('default', 'normal', '22px/1.2')};
    color: ${({ theme }) => theme.palette.primary.alphaDark};
    ${bp('sm', 'min-width')`
      padding: 0 40px;
    `}

    &:first-child {
      font: ${font('default', 'medium', '36px/1.2')};
    }
  }

  .actions {
    margin-top: 40px;

    > button {
      margin: auto;
      text-transform: uppercase;
      font: ${font('default', 'bold', '20px/1.2')};
      letter-spacing: 1px;
      background: ${({ theme }) => theme.palette.primary.beta};

      &:hover {
        background: ${props => darken(0.1, props.theme.palette.primary.beta)};
      }
    }
  }
`

export const Wrapper = styled.div`
  h1 {
    background: ${({ theme }) => theme.palette.primary.alphaDark};
    color: ${({ theme }) => theme.palette.general.light};
    text-transform: uppercase;
    text-align: center;
    font: ${font('default', 'bold', '40px/1.5')};
    font-size: clamp(50px, 80px, 6.5vw);
    padding: 20px 0;
    margin-top: 0;
  }

  .survey-wrapper {
    width: 100%;
    background: ${({ theme }) => theme.palette.general.soft};
    margin-top: 50px;

    > div {
      box-shadow: none;
    }

    > h2 {
      font: ${font('default', 'normal', '40px/1.2')};
      color: ${({ theme }) => theme.palette.primary.alphaDark};
      text-align: center;
      padding: 0 20px;
    }
  }
`

export const OrderSuccessContentWrapper = styled.div`
  margin-bottom: 40px;
  margin-top: 40px;
  width: 100%;
`
